import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { useHeight } from "../hooks/index.js";
import { useAdditionalFetchDataHelpersPluginCallback } from "../../AdditionalFetchDataHelpersPlugin/index.js";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { useIsDesktop } from "../../../../../hooks/index.js";
import { WysiwygContext } from "../../../context/index.js";
import { useLogger } from "../../../../../services/hooks/index.js";
import { ImageComponent } from "./ImageComponent.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const IMAGE_HEIGHT_SIZE_L = '252';
const IMAGE_WIDTH_SIZE_L = '448';
const IMAGE_HEIGHT_SIZE_S = '130';
const IMAGE_WIDTH_SIZE_S = '232';
const getCurrentCommentsImageSize = (isDesktop)=>{
    if (isDesktop) return {
        height: `${IMAGE_HEIGHT_SIZE_L}px`,
        width: `${IMAGE_WIDTH_SIZE_L}px`
    };
    return {
        height: `${IMAGE_HEIGHT_SIZE_S}px`,
        width: `${IMAGE_WIDTH_SIZE_S}px`
    };
};
const Image = (t0)=>{
    const $ = c(49);
    const { alt, description, id, mode, editable } = t0;
    const { editorHeight, maxHeight, minHeight } = useHeight();
    const isDesktop = useIsDesktop();
    const contextHelpers = useAdditionalFetchDataHelpersPluginCallback();
    const isComments = "comments" === mode;
    const { apiUrl } = useContext(WysiwygContext);
    const logger = useLogger();
    const [src, setSrc] = useState("");
    const [hasError, setHasError] = useState(false);
    let t1;
    if ($[0] !== contextHelpers || $[1] !== id || $[2] !== logger || $[3] !== src) {
        t1 = ()=>{
            if (src) return;
            if (null == contextHelpers ? void 0 : contextHelpers.getAttachmentUrl) {
                const fetchAttachmentUrl = ()=>_async_to_generator(function*() {
                        if (contextHelpers.getAttachmentUrl) yield contextHelpers.getAttachmentUrl(id).then((res)=>{
                            setSrc(()=>res);
                        }).catch((err)=>{
                            logger.error(err, {
                                tags: {
                                    vkdoc_error_type: "wysiwyg input image node"
                                }
                            });
                            setHasError(_temp);
                        });
                    })();
                fetchAttachmentUrl();
            }
        };
        $[0] = contextHelpers;
        $[1] = id;
        $[2] = logger;
        $[3] = src;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== apiUrl || $[6] !== contextHelpers || $[7] !== id || $[8] !== logger || $[9] !== src) {
        t2 = [
            src,
            id,
            contextHelpers,
            apiUrl,
            logger
        ];
        $[5] = apiUrl;
        $[6] = contextHelpers;
        $[7] = id;
        $[8] = logger;
        $[9] = src;
        $[10] = t2;
    } else t2 = $[10];
    useEffect(t1, t2);
    let T0;
    let T1;
    let commentsWidth;
    let t10;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[11] !== alt || $[12] !== editable || $[13] !== editorHeight || $[14] !== id || $[15] !== isComments || $[16] !== isDesktop || $[17] !== maxHeight || $[18] !== minHeight || $[19] !== src) {
        const { height: commentsHeight, width: t11 } = getCurrentCommentsImageSize(isDesktop);
        commentsWidth = t11;
        const calculateMaxHeight = ()=>{
            if (isComments) return commentsHeight;
            if (editable) return editorHeight;
            return maxHeight;
        };
        const calculateMinHeight = ()=>{
            if (isComments) return commentsHeight;
            return minHeight;
        };
        T1 = Box;
        t7 = "flex";
        t8 = "column";
        t9 = "12";
        t10 = id;
        T0 = ImageComponent;
        t3 = alt;
        t4 = src;
        t5 = calculateMaxHeight();
        t6 = calculateMinHeight();
        $[11] = alt;
        $[12] = editable;
        $[13] = editorHeight;
        $[14] = id;
        $[15] = isComments;
        $[16] = isDesktop;
        $[17] = maxHeight;
        $[18] = minHeight;
        $[19] = src;
        $[20] = T0;
        $[21] = T1;
        $[22] = commentsWidth;
        $[23] = t10;
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else {
        T0 = $[20];
        T1 = $[21];
        commentsWidth = $[22];
        t10 = $[23];
        t3 = $[24];
        t4 = $[25];
        t5 = $[26];
        t6 = $[27];
        t7 = $[28];
        t8 = $[29];
        t9 = $[30];
    }
    const t11 = isComments ? commentsWidth : "100%";
    let t12;
    if ($[31] !== T0 || $[32] !== hasError || $[33] !== t11 || $[34] !== t3 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6) {
        t12 = /*#__PURE__*/ jsx(T0, {
            alt: t3,
            src: t4,
            maxHeight: t5,
            minHeight: t6,
            width: t11,
            hasError: hasError
        });
        $[31] = T0;
        $[32] = hasError;
        $[33] = t11;
        $[34] = t3;
        $[35] = t4;
        $[36] = t5;
        $[37] = t6;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== description) {
        t13 = description && /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "text.light.tertirary",
            children: description
        });
        $[39] = description;
        $[40] = t13;
    } else t13 = $[40];
    let t14;
    if ($[41] !== T1 || $[42] !== t10 || $[43] !== t12 || $[44] !== t13 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
        t14 = /*#__PURE__*/ jsxs(T1, {
            display: t7,
            flexDirection: t8,
            gap: t9,
            id: t10,
            children: [
                t12,
                t13
            ]
        });
        $[41] = T1;
        $[42] = t10;
        $[43] = t12;
        $[44] = t13;
        $[45] = t7;
        $[46] = t8;
        $[47] = t9;
        $[48] = t14;
    } else t14 = $[48];
    return t14;
};
function _temp() {
    return true;
}
export { Image };
